import { render, staticRenderFns } from "./InsertPkgCodeTpl.vue?vue&type=template&id=2b83dbdc&scoped=true&"
import script from "./InsertPkgCodeTpl.vue?vue&type=script&lang=js&"
export * from "./InsertPkgCodeTpl.vue?vue&type=script&lang=js&"
import style0 from "./InsertPkgCodeTpl.vue?vue&type=style&index=0&id=2b83dbdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83dbdc",
  null
  
)

export default component.exports